<template>
  <el-select v-model="v" placeholder="请选择小组" :size="size" filterable clearable>
    <el-option v-for="item in organizationOptions" :key="item.id" :value="item.id" :label="item.label"/>
  </el-select>
</template>

<script>
import {options} from "@/api/organization";

export default {
  name: "select-team",
  props: ['value', 'size'],
  data() {
    return {
      v: null,
      organizationOptions: [],
    }
  },
  watch: {
    v(_) {
      this.$emit('update:value', _)
    }
  },
  created() {
    this.getTeamList()
  },
  methods: {
    async getTeamList() {
      this.organizationOptions = [];
      const res = await options()
      if (!res.success) {
        this.$message.error(res.message);
        return
      }
      this.organizationOptions = res.model;
    },
  }
}
</script>

<style scoped>

</style>